import { useResource } from '../../../Hooks/UseResource';

function RegistrationResource() {
  const[resourceError, loading, getData, postData] =useResource();

   const getNavigationDetails =(navigationDetailDTO)=>{
        return postData( {url:'public/navigation-details',data:navigationDetailDTO});     
   }

   const getNavigationDetailsFromDB =(navigationDetailDTO)=>{
    return postData( {url:'public/navigation-details-from-db',data:navigationDetailDTO});     
  }

  const checkAadhaarXmlProfileStatus=(navigationDetailDTO)=>{
   return postData({url:'public/check-aadhaar-xml-profile-status',data:navigationDetailDTO})
  }

  const getCKYCDetails=(applicationEntityDetailDTO)=>{
    return postData({url:'public/ckyc-search',data:applicationEntityDetailDTO})
   }

  const verifyOTP = (applicationEntityDetailDTO)=>{
    return postData({url:'public/verify-ckyc-by-otp',data:applicationEntityDetailDTO})
  }

  const resendOTP=(applicationEntityDetailDTO)=>{
       return postData({url:'public/resend-ckyc-otp',data:applicationEntityDetailDTO})
  }

  const getAadharDetails=(applicationSessionToken, holderType) =>{
    return postData({
      url: 'public/proceed-aadhar-flow', data: {
           "kycApplicationId": applicationSessionToken,
           "holderType": holderType
      }
 })
  }

    return {getNavigationDetails,getNavigationDetailsFromDB,checkAadhaarXmlProfileStatus,getCKYCDetails,verifyOTP,resendOTP,getAadharDetails}

}

export default RegistrationResource;